import {api} from '../../api';
import {createMutation} from '../../lib';

const {putContracts} = api.contracts;

export const usePutContractsMutation = createMutation((params: Parameters<typeof putContracts>) =>
  putContracts(...params),
);
